import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import router from './router'
import store from './store'
import 'element-ui/lib/theme-chalk/index.css'
import './plugins/globalElement'
import '../assets/index.scss'
import initAnalytics from './plugins/analytics'
import generateStyleVariables from './util/generateCssVariables'
import setLocale from './plugins/i18n'
import importFontFamily from './util/importFontFamily'

Vue.config.productionTip = false

function checkMountElement(mountId) {
  const parts = mountId.split('#')
  mountId = parts[parts.length - 1]
  let mountDiv = document.getElementById(mountId)
  if (!mountDiv) {
    mountDiv = document.createElement('div')
    mountDiv.setAttribute('id', mountId)
    if (!document.body) {
      document.body = document.createElement('body')
    }
    document.body.appendChild(mountDiv)
  }
}

function validateColor(color) {
  return (!defaultOptions[color].includes('#') || defaultOptions[color].length !== 7)
}

function addHtmlAttribute() {
  const htmlElement = document.querySelector("html");
  if (htmlElement) {
    htmlElement.setAttribute('jobwidget', 'true')
  }
}

const defaultOptions = {
  BASE_URL: 'https://api.jobboard.stg.exenzo.com',
  JOBS_PER_PAGE: '10',
  JOB_BOARD_ID: '1',
  JOB_OPEN_URL: false,
  SEGMENT_IDS: [],
  ORGANIZATION_ID: null,
  JOB_POST_LINK: null,
  JOB_POST_TEXT: null,
  GA_KEY: 'UA-157028937-2',
  PRIMARY_COLOR: '#319795',
  DANGER_COLOR: '#E53E3E',
  LANGUAGE: 'en',
  SHOW_LOCATION_SEARCH: true,
  SHOW_RANGE_SELECT: true,
  SHOW_SEGMENT_LIST: true,
  SHOW_CREATE_ALERT: false,
  SEGMENT_LIMIT: 6,
  SEGMENT_LIST_POSITION: 'left',
  FONT_FAMILY: `"Trebuchet MS", 'Helvetica Neue', Helvetica, Tahoma, sans-serif`
}

class JobsWidget {
  constructor(options = {}) {
    this.options = {
      ...defaultOptions,
      ...options
    }
    this.options.BASE_URL = options.baseURL || defaultOptions.BASE_URL
    this.options.JOBS_PER_PAGE = options.josPerPage || defaultOptions.JOBS_PER_PAGE
    this.options.JOB_BOARD_ID = options.jobBoardId || defaultOptions.JOB_BOARD_ID
    this.options.JOB_OPEN_URL = options.jobOpenUrl || defaultOptions.JOB_OPEN_URL
    this.options.SEGMENT_IDS = options.segmentIds || defaultOptions.SEGMENT_IDS
    this.options.ORGANIZATION_ID = options.organizationId || defaultOptions.ORGANIZATION_ID
    this.options.JOB_POST_LINK = options.jobPostLink || defaultOptions.JOB_POST_LINK
    this.options.JOB_POST_TEXT = options.jobPostText || defaultOptions.JOB_POST_TEXT
    this.options.GA_KEY = options.gaKey || defaultOptions.GA_KEY
    this.options.PRIMARY_COLOR = options.primaryColor || defaultOptions.PRIMARY_COLOR
    this.options.DANGER_COLOR = options.dangerColor || defaultOptions.DANGER_COLOR
    this.options.FONT_FAMILY = options.fontFamily || defaultOptions.FONT_FAMILY
    if (validateColor('PRIMARY_COLOR')) this.options.PRIMARY_COLOR = '#FC990E'
    if (validateColor('DANGER_COLOR')) this.options.DANGER_COLOR = '#E53E3E'
    this.options.LANGUAGE = options.language || defaultOptions.LANGUAGE
    if(options.showLocationSearch === undefined) {
      this.options.SHOW_LOCATION_SEARCH = defaultOptions.SHOW_LOCATION_SEARCH
    } else {
      this.options.SHOW_LOCATION_SEARCH = options.showLocationSearch
    }
    if(options.showRangeSelect === undefined) {
      this.options.SHOW_RANGE_SELECT = defaultOptions.SHOW_RANGE_SELECT
    } else {
      this.options.SHOW_RANGE_SELECT = options.showRangeSelect
    }
    if(options.showCreateAlert === undefined) {
      this.options.SHOW_CREATE_ALERT = defaultOptions.SHOW_CREATE_ALERT
    } else {
      this.options.SHOW_CREATE_ALERT = options.showCreateAlert
    }
    this.options.SEGMENT_LIMIT = options.segmentLimit || defaultOptions.SEGMENT_LIMIT
    this.options.SEGMENT_LIST_POSITION = options.segmentListPosition || defaultOptions.SEGMENT_LIST_POSITION
    if(options.showSegmentList === undefined) {
      this.options.SHOW_SEGMENT_LIST = defaultOptions.SHOW_SEGMENT_LIST
    } else {
      this.options.SHOW_SEGMENT_LIST = options.showSegmentList
    }
    axios.defaults.baseURL = this.options.BASE_URL
    axios.defaults.headers.locale = this.options.LANGUAGE
    this.initApplication()
  }

  initApplication() {
    let i18n = setLocale(this.options.LANGUAGE)
    const mountId = this.options.el || '#app'
    checkMountElement(mountId)
    store.commit('SET_WIDGET_OPTIONS', this.options)
    store.dispatch('getConfig')
    initAnalytics()
    generateStyleVariables(this.options.PRIMARY_COLOR, this.options.DANGER_COLOR)
    importFontFamily(this.options.FONT_FAMILY)
    addHtmlAttribute()
    new Vue({
      i18n,
      router,
      store,
      render: h => h(App)
    }).$mount(mountId)
  }
}
export default JobsWidget
